import AnimatedBackground from './AnimatedBackground';
import { ClientOnly } from './ClientOnly';

const Background = () => {
    return (
        <div className="fixed inset-0 -z-10 bg-black">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-pink-900/20" />
            <ClientOnly>
                <AnimatedBackground />
            </ClientOnly>
        </div>
    );
};

export default Background;
